<div class="eventRow {{ customClass }} hover:shadow-lg" [ngClass]="['out-of-time', 'on-time', 'rescheduled'][status]">
    <small>{{ title }}</small>
</div>